import { render } from "./DmallPos.vue?vue&type=template&id=38006b79"
import script from "./DmallPos.vue?vue&type=script&lang=js"
export * from "./DmallPos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__